import { OrganizationUserDto } from 'src/app/data-transfer/entities/organization-user-dto';

export enum AdminUserRole {
  Lead = 'lead',
  Admin = 'admin',
  Member = 'member',
}

export const ADMIN_USER_ROLE_ICONS: Record<AdminUserRole, string> = {
  [AdminUserRole.Lead]: 'shield',
  [AdminUserRole.Admin]: 'admin_panel_settings',
  [AdminUserRole.Member]: 'person',
};

export const getUserDisplayName = (user: Pick<OrganizationUserDto, 'firstName' | 'lastName'>): string => `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();

export const getUserRole = (user: Pick<OrganizationUserDto, 'isOrganizationLeadAdmin' | 'isOrganizationAdmin'>): AdminUserRole => {
  if (user.isOrganizationLeadAdmin) return AdminUserRole.Lead;
  return user.isOrganizationAdmin ? AdminUserRole.Admin : AdminUserRole.Member;
};